import React,{useState,useRef} from 'react';
import {Link,useLocation} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMenu,FiX,FiChevronDown,FiGlobe}=FiIcons;

function Header() {
  const [isMenuOpen,setIsMenuOpen]=useState(false);
  const [isServicesOpen,setIsServicesOpen]=useState(false);
  const [isRegionsOpen,setIsRegionsOpen]=useState(false);
  const hoverTimeoutRef=useRef(null);
  const regionsTimeoutRef=useRef(null);
  const location=useLocation();

  const navigation=[
    {name: 'Home',href: '/'},
    {name: 'Services',href: '/services',dropdown: [
      {name: 'Content Marketing',href: '/services'},
      {name: 'Digital Transformation',href: '/digital-transformation-consulting'},
      {name: 'Business Training',href: '/business-training-certification'},
      {name: 'No-Code Development',href: '/no-code-development'},
      {name: 'Engagement Growth Engine',href: '/engagement-growth-engine'}
    ]},
    {name: 'Regions',href: '#',dropdown: [
      {name: '🇳🇬 Nigeria Market',href: '/nigeria'},
      {name: '🇺🇸 North America',href: '/contact'},
      {name: '🌍 Global Services',href: '/contact'}
    ]},
    {name: 'Contact',href: '/contact'}
  ];

  const isActive=(path)=> location.pathname===path;

  const handleServicesClick=()=> {
    setIsServicesOpen(!isServicesOpen);
    setIsRegionsOpen(false);
  };

  const handleRegionsClick=()=> {
    setIsRegionsOpen(!isRegionsOpen);
    setIsServicesOpen(false);
  };

  const handleDropdownItemClick=()=> {
    setIsServicesOpen(false);
    setIsRegionsOpen(false);
  };

  const handleServicesMouseEnter=()=> {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current=null;
    }
    setIsServicesOpen(true);
    setIsRegionsOpen(false);
  };

  const handleServicesMouseLeave=()=> {
    hoverTimeoutRef.current=setTimeout(()=> {
      setIsServicesOpen(false);
    },300);
  };

  const handleRegionsMouseEnter=()=> {
    if (regionsTimeoutRef.current) {
      clearTimeout(regionsTimeoutRef.current);
      regionsTimeoutRef.current=null;
    }
    setIsRegionsOpen(true);
    setIsServicesOpen(false);
  };

  const handleRegionsMouseLeave=()=> {
    regionsTimeoutRef.current=setTimeout(()=> {
      setIsRegionsOpen(false);
    },300);
  };

  React.useEffect(()=> {
    return ()=> {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      if (regionsTimeoutRef.current) {
        clearTimeout(regionsTimeoutRef.current);
      }
    };
  },[]);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757818262760-Untitled%20design%20%282%29.png"
                alt="Handvantage"
                className="h-8 w-auto"
              />
              <span style={{color: 'rgb(30,58,138)'}} className="text-2xl font-bold text-blue-900">AllGrowth</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item)=> (
              <div key={item.name} className="relative">
                {item.dropdown ? (
                  <div
                    className="relative"
                    onMouseEnter={item.name==='Services' ? handleServicesMouseEnter : handleRegionsMouseEnter}
                    onMouseLeave={item.name==='Services' ? handleServicesMouseLeave : handleRegionsMouseLeave}
                  >
                    <button
                      onClick={item.name==='Services' ? handleServicesClick : handleRegionsClick}
                      className={`flex items-center space-x-1 text-sm font-medium transition-colors py-2 px-1 ${
                        (item.name==='Services' && (isActive(item.href) || item.dropdown.some(sub=> isActive(sub.href)))) ||
                        (item.name==='Regions' && location.pathname==='/nigeria')
                          ? 'text-blue-600 border-b-2 border-blue-600'
                          : 'text-gray-700 hover:text-blue-600'
                      }`}
                    >
                      <span>{item.name}</span>
                      <SafeIcon
                        icon={FiChevronDown}
                        className={`h-4 w-4 transition-transform duration-200 ${
                          (item.name==='Services' && isServicesOpen) || (item.name==='Regions' && isRegionsOpen)
                            ? 'rotate-180'
                            : ''
                        }`}
                      />
                    </button>
                    {((item.name==='Services' && isServicesOpen) || (item.name==='Regions' && isRegionsOpen)) && (
                      <div
                        className="absolute top-full left-0 mt-0 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50"
                        onMouseEnter={item.name==='Services' ? handleServicesMouseEnter : handleRegionsMouseEnter}
                        onMouseLeave={item.name==='Services' ? handleServicesMouseLeave : handleRegionsMouseLeave}
                      >
                        {item.dropdown.map((subItem)=> (
                          <Link
                            key={subItem.name}
                            to={subItem.href}
                            onClick={handleDropdownItemClick}
                            className="block px-4 py-3 text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors"
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.href}
                    className={`text-sm font-medium transition-colors py-2 px-1 ${
                      isActive(item.href)
                        ? 'text-blue-600 border-b-2 border-blue-600'
                        : 'text-gray-700 hover:text-blue-600'
                    }`}
                  >
                    {item.name}
                  </Link>
                )}
              </div>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <Link style={{
      color: 'rgb(255, 255, 255)'
    }}
              to="/book-consultation"
              className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
            >Book Your Strategy Call</Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={()=> setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-gray-100"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {navigation.map((item)=> (
                <div key={item.name}>
                  {item.dropdown ? (
                    <div>
                      <button
                        onClick={()=> {
                          if (item.name==='Services') {
                            setIsServicesOpen(!isServicesOpen);
                          } else {
                            setIsRegionsOpen(!isRegionsOpen);
                          }
                        }}
                        className={`flex items-center justify-between w-full text-left text-base font-medium py-2 ${
                          (item.name==='Services' && (isActive(item.href) || item.dropdown.some(sub=> isActive(sub.href)))) ||
                          (item.name==='Regions' && location.pathname==='/nigeria')
                            ? 'text-blue-600'
                            : 'text-gray-700'
                        }`}
                      >
                        <span>{item.name}</span>
                        <SafeIcon
                          icon={FiChevronDown}
                          className={`h-4 w-4 transition-transform duration-200 ${
                            (item.name==='Services' && isServicesOpen) || (item.name==='Regions' && isRegionsOpen)
                              ? 'rotate-180'
                              : ''
                          }`}
                        />
                      </button>
                      {((item.name==='Services' && isServicesOpen) || (item.name==='Regions' && isRegionsOpen)) && (
                        <div className="ml-4 mt-2 space-y-2">
                          {item.dropdown.map((subItem)=> (
                            <Link
                              key={subItem.name}
                              to={subItem.href}
                              onClick={()=> {
                                setIsMenuOpen(false);
                                setIsServicesOpen(false);
                                setIsRegionsOpen(false);
                              }}
                              className="block text-sm text-gray-600 hover:text-blue-600 py-2"
                            >
                              {subItem.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      onClick={()=> setIsMenuOpen(false)}
                      className={`text-base font-medium py-2 block ${
                        isActive(item.href) ? 'text-blue-600' : 'text-gray-700'
                      }`}
                    >
                      {item.name}
                    </Link>
                  )}
                </div>
              ))}
              <Link
                to="/book-consultation"
                onClick={()=> setIsMenuOpen(false)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-center font-medium"
              >
                Strategy Call
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;